import type { Components, Theme } from '@mui/material/styles';
import { UIColors } from '../../constants/UIConstants';

const NAVY = UIColors.primary.navyBlue;
const SELECTED_BG = 'rgba(38, 38, 109, 0.08)';

const menuItemHoverStyles = {
  color: '#FFFFFF',
  backgroundColor: NAVY,
  '& .MuiTypography-root': {
    color: '#FFFFFF',
  },
  '& .org-menu-role': {
    color: 'rgba(255, 255, 255, 0.85)',
  },
};

export const themeComponents: Components<Theme> = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        color: NAVY,
        // Scope list styles to open menu surfaces only (not stray Select nodes).
        '.MuiMenu-paper &': {
          '&&:hover': menuItemHoverStyles,
          '&&.Mui-selected': {
            color: NAVY,
            backgroundColor: SELECTED_BG,
            fontWeight: 600,
            '&:hover': menuItemHoverStyles,
          },
        },
        '&&.Mui-disabled:hover': {
          color: 'inherit',
          backgroundColor: 'transparent',
          '& .MuiTypography-root': {
            color: 'inherit',
          },
        },
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      option: {
        color: NAVY,
        '&&:hover': menuItemHoverStyles,
        '&&.Mui-focused': menuItemHoverStyles,
        '&&[aria-selected="true"]': {
          color: NAVY,
          backgroundColor: SELECTED_BG,
          fontWeight: 600,
          '&.Mui-focused': menuItemHoverStyles,
          '&:hover': menuItemHoverStyles,
        },
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        '&.Mui-focusVisible': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
};
